export default __webpack_public_path__ + "../staticImages/WSH-260.png";